import AccountSelection from './AccountSelection.container';

export default AccountSelection;
